export default "__VITE_ASSET__2e851fda__"